<div class="loading-overlay" *ngIf="isLoading">
  <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
</div>

<div class="title">
  <h1>Grupo de empresas</h1>
  <button matButton="filled" *ngIf="isMasterUser()" [disabled]="!temEmpresasNoSistema" (click)="navegarParaCadastroGrupo()">
    <span style="margin-right: 6px; font-size: 16px">+</span>Adicionar novo
  </button>
</div>

<hr class="divider" />

<div class="sem-dados-disclaimer" *ngIf="!temEmpresasNoSistema && !isLoading">
  <div>
    <img src="../../../../assets/svg/icons/blue_explanation.svg" alt="">
    <p>Para cadastrar um grupo, é preciso que haja empresas previamente cadastradas no sistema.</p>
  </div>
  <button matButton="filled" (click)="navegarParaCadastroEmpresa()">
    <span style="margin-right: 6px; font-size: 16px">+</span>Cadastrar empresas
  </button>
</div>

<div class="filters" *ngIf="temEmpresasNoSistema">
  <mat-form-field appearance="outline" class="custom-outline-red">
    <mat-label>Buscar por nome</mat-label>
    <img matPrefix src="../../../../../assets/svg/icons/search.svg" alt="Lupa" class="search-icon" />
    <input matInput type="text" placeholder=" " [(ngModel)]="searchFilter" (input)="filterGrupos()" />
  </mat-form-field>
</div>

<div class="grupos" *ngIf="temEmpresasNoSistema && filteredGrupos.length > 0">
  <div class="grupo" *ngFor="let grupo of filteredGrupos">
    <span>{{ grupo.nome }}</span>
    <button matButton="outlined" (click)="acessarGrupo(grupo.id)">
      Acessar
    </button>
  </div>
</div>

<div class="sem-dados" *ngIf="temEmpresasNoSistema && this.grupos.length === 0 && !isLoading">
  <p>Nenhum grupo de empresas foi cadastrado no sistema.</p>
</div>

<div class="sem-dados"
  *ngIf="temEmpresasNoSistema && this.grupos.length !== 0 && filteredGrupos.length === 0 && !isLoading">
  <p>Nenhum grupo de empresas foi encontrado.</p>
</div>

<div class="sem-dados" *ngIf="!temEmpresasNoSistema && this.grupos.length === 0 && !isLoading">
  <p>Nenhum grupo de empresas foi cadastrado no sistema.</p>
</div>